import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetCatalogTagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCatalogTagsQuery = { __typename?: 'query_root', tags?: Types.Maybe<{ __typename?: 'TagEntityResponseCollection', data: Array<{ __typename?: 'TagEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'Tag', name: string, slug: string }> }> }> };


export const GetCatalogTagsDocument = gql`
    query getCatalogTags {
  tags {
    data {
      id
      attributes {
        name
        slug
      }
    }
  }
}
    `;
export function useGetCatalogTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogTagsQuery, GetCatalogTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogTagsQuery, GetCatalogTagsQueryVariables>(GetCatalogTagsDocument, options);
      }
export function useGetCatalogTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogTagsQuery, GetCatalogTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogTagsQuery, GetCatalogTagsQueryVariables>(GetCatalogTagsDocument, options);
        }
export type GetCatalogTagsQueryHookResult = ReturnType<typeof useGetCatalogTagsQuery>;
export type GetCatalogTagsLazyQueryHookResult = ReturnType<typeof useGetCatalogTagsLazyQuery>;
export type GetCatalogTagsQueryResult = Apollo.QueryResult<GetCatalogTagsQuery, GetCatalogTagsQueryVariables>;